module.exports = __webpack_public_path__ + "img/resertname.79d8be2f.png";